import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_106: FaireProductEntity = {
  token: "starter_collection_106",
  type: "product",
  name: "Best Wine Key - Tortoise",
  brandName: "Craighill",
  imageUrl:
    '"https://cdn.faire.com/fastly/b38a0a4db65e400a44f7dc4a519f534cd42c4f58073503d9795b7d933d3d6a4a.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2203',
  priceDollars: 48,
  msrpDollars: 96,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
